export enum CanStartOn {
  Immediately = 'immediately',
  WithinTwoMonths = 'within_two_months',
  WithinSixMonths = 'within_six_months',
  WithinSixToTwelveMonths = 'within_six_to_twelve_months',
  ThisYear = 'this_year',
  NextYear = 'next_year',
  DontKnow = 'i_dont_know',
  JustLooking = 'looking_around',
}

export const CAN_START_ON_TRANSLATIONS = {
  [CanStartOn.Immediately]: 'Ab sofort',
  [CanStartOn.WithinTwoMonths]: 'Innerhalb der nächsten 2 Monate',
  [CanStartOn.WithinSixMonths]: 'Innerhalb der nächsten 6 Monate',
  [CanStartOn.WithinSixToTwelveMonths]: 'In 6 bis 12 Monaten',
  [CanStartOn.ThisYear]: 'Dieses Jahr',
  [CanStartOn.NextYear]: 'Nächstes Jahr',
  [CanStartOn.DontKnow]: 'Noch unklar',
  [CanStartOn.JustLooking]: 'Nur mal umschauen',
};

export const DISABLED_CAN_START_ON = [
  CanStartOn.WithinSixToTwelveMonths,
  CanStartOn.ThisYear,
  CanStartOn.NextYear,
  CanStartOn.DontKnow,
  CanStartOn.JustLooking,
];
